export default "__VITE_ASSET__90e07af6__"